import {FormViewerRouteParams} from "@/types";

export default function urlGenerator(formId: string, pageNumber: number, hiddenUrlParams: { string: string } | undefined): FormViewerRouteParams {
    return {
        ...(hiddenUrlParams ? hiddenUrlParams : {}),
        form: formId,
        page: pageNumber,
    }
}
